<div id="assessment-map" style="height: 100%; width: 100%" #map>
</div>
